/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { ZoneContextManager } from './ZoneContextManager';
export type { Func, TargetWithEvents } from './types';
